import { useContext, useRef, useEffect } from 'react'

import ModalBase from 'LuxKit/Modal/ModalBase'
import FlightSearchWidgetDispatchContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetDispatchContext'
import { FlightSearchWidgetActions } from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateReducer'
import { GlobalSearchDispatchContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import { ViewStateActions } from 'tripPlanner/contexts/View/ViewState'
import { useView } from 'tripPlanner/hooks/View/useView'

function ModalWrap() {
  const { viewDispatch, viewState } = useView()

  const ref = useRef<HTMLDivElement>(null)

  const globalSearchDispatch = useContext(GlobalSearchDispatchContext)
  const flightSearchDispatch = useContext(FlightSearchWidgetDispatchContext)

  useEffect(() => {
    if (viewState.isModalOpen && ref.current) {
      // Scroll to top on view change
      ref.current.scrollTop = 0
    }
  }, [viewState.isModalOpen, viewState.currentView])

  const tabletHeight =
    !viewState.currentView.config?.height &&
    !viewState.currentView.config?.tabletHeight ?
      'auto' :
      viewState.currentView.config?.tabletHeight

  return (
    <ModalBase
      isOpen={viewState.isModalOpen}
      height={viewState.currentView.config?.height ?? 'full'}
      tabletHeight={tabletHeight}
      size={viewState.currentView.config?.size || 'S'}
      onClose={() => viewDispatch({ type: ViewStateActions.MODAL_CLOSE })}
      ref={ref}
      onAfterClose={() => {
        viewDispatch({ type: ViewStateActions.MODAL_RESET })
        globalSearchDispatch({ type: GlobalSearchStateActions.RESET_STATE })
        flightSearchDispatch({ type: FlightSearchWidgetActions.RESET_STATE })
      }}
    >
      <viewState.currentView.component {...viewState.currentView.props} />
    </ModalBase>
  )
}

export default ModalWrap
